<template>
  <div class="news-subscribe">
    <div class="news-subscribe-main">
      <DefTitle :result="1" :center="screenWidth < 768">
        <h2>{{ result.messages.title }}</h2>
      </DefTitle>
      <div
        class="news-subscribe-text"
        v-html="
          changePartTextColor(
            result.messages.text,
            '3%',
            'background-color: #618EAF; border-radius: 4px; font-weight: 600; color: #fff; padding: 3px 8px 0 8px'
          )
        "
      ></div>
      <div v-if="responseText !== ''" class="news-subscribe-response" v-html="responseText"></div>
      <form
        :method="result.route.method"
        :action="result.route.action"
        class="news-subscribe-form"
        @submit.prevent="handlerSubmit($event)"
      >
        <input type="hidden" name="action" value="subscribe" />
        <input type="hidden" name="LANGUAGE_ID" :value="result.form.LANGUAGE_ID" />
        <DefEmail
          v-if="responseText === '' || badResponse"
          :name="result.form.inputName"
          required
          :placeholder="result.messages.placeholder"
        />
        <DefButtonPrimary v-if="responseText === '' || badResponse" type="submit">
          <!--          {{ screenWidth >= 768 ? result.messages.button.desktop : result.messages.button.mobile }}-->
          {{ result.messages.button.desktop }}
        </DefButtonPrimary>
      </form>
    </div>

    <!--    <div class="news-subscribe-img" :style="`background-image: url(${result.picture.src})`"></div>-->
    <div>
      <DefPicture :result="result?.pictures" />
    </div>
  </div>
</template>
<script>
import { screenWidth } from '@use/useDeviceInfo';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefEmail from '@components/Def/DefEmail/DefEmail.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';

export default {
  name: 'NewsSubscribe',
  components: { DefPicture, DefButtonPrimary, DefEmail, DefTitle },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      responseText: '',
      badResponse: false,
      screenWidth,
    };
  },
  methods: {
    handlerSubmit({ target }) {
      try {
        const formData = new FormData(target);
        fetch(this.result.route.action, {
          method: this.result.route.method,
          body: formData,
        })
          .then((res) => res.json())
          .then(({ response }) => {
            if (response.status) {
              this.responseText = response.text;
            } else {
              this.responseText = response.text;
              this.badResponse = true;
            }
          });
      } catch (err) {
        console.error(err);
      }
    },
    changePartTextColor(textString, search, style) {
      return textString.replace(search, `<span style="${style}">${search}</span>`);
    },
  },
};
</script>

<style lang="scss" scoped>
.news-subscribe {
  background-color: #fff;
  margin-bottom: 56px;
  @include point-md {
    display: grid;
    align-items: center;
    grid-template-columns: minmax(0, 1fr) 280px;
    margin-bottom: 80px;
  }
  @include point-lg {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-bottom: 100px;
  }
  :deep(.def-picture) {
    img {
      width: 100%;
    }
  }
}
.news-subscribe-main {
  padding: 32px 16px;
  @include point-md {
    padding: 32px 24px;
  }
  @include point-lg {
    padding: 60px 50px;
  }
}
.news-subscribe-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  text-align: center;
  margin-bottom: 16px;
  color: #363636;
  @include point-md {
    margin-bottom: 24px;
    text-align: left;
  }
}
.news-subscribe-response {
  font-weight: 500;
  font-size: rem(18);
  text-align: center;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-colour-primary);
  margin-top: auto;
  @include point-lg {
    font-size: rem(24);
  }
}
.news-subscribe-form {
  display: grid;
  grid-row-gap: 12px;
  @include point-md {
    display: flex;
  }
  :deep(.def-email) {
    flex-grow: 1;
  }
  :deep(.def-button-primary) {
    height: 56px;

    font-size: 14px;
    letter-spacing: 1.12px;
    padding: 0 32px;
    @include point-lg {
      padding: 0 40px;
    }
  }
}
//.news-subscribe-img {
//  align-self: stretch;
//  background-repeat: no-repeat;
//  background-size: cover;
//  background-position: center;
//  height: 280px;
//  @include point-md {
//    height: unset;
//  }
//}
</style>
